module.exports = __webpack_public_path__ + "static/media/occasions-main.abddbe87.jpg";